import React, { useEffect } from "react";
import Layout from "../../../components/layouts/Layout";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import SubmitButton from "../../../components/form/SubmitButton";
import LoadingButton from "../../../components/form/LoadingButton";
import LoadingErrorState from "../../../components/ui/LoadingErrorState";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import ContactInfoForm, { ContactInfoFormData } from "../../../components/admin/contactInfo/ContactInfoForm";
import { useContactInfoByAdmin } from "../../../hooks/admin/contactInfo.admin";

export default function ContactInfoAdminPage() {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useContactInfoByAdmin();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ContactInfoFormData>({
    defaultValues: {
      phoneNumber: "",
      email: "",
      country: "",
    },
  });

  useEffect(() => {
    if (data) {
      setValue("phoneNumber", data.phoneNumber);
      setValue("email", data.email);
      setValue("country", data.country);
    }
  }, [data, setValue]);

  const { loading, updateResource } = useUpdateResource();

  const onSubmit = async (formData: ContactInfoFormData) => {
    await updateResource(
      `system-setting`,
      formData,
      "admin",
      {
        method: "POST",
        successMessage: t("updatedSuccess"),
        invalidateQueries: ["contact-info-by-admin"],
      }
    );
  };

  return (
    <Layout title={t("admin_sidebar.contact_settings")} headline="">
      <LoadingErrorState isError={isError} isLoading={isLoading} />
      {data && (
        <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow">
          <form onSubmit={handleSubmit(onSubmit)}>
            <ContactInfoForm
              register={register}
              errors={errors}
              defaultValues={data}
              onSave={handleSubmit(onSubmit)}
            />
            <div className="mt-6">
              {loading ? <LoadingButton /> : <SubmitButton label="update" />}
            </div>
          </form>
        </div>
      )}
    </Layout>
  );
}
